import { Injectable, Renderer2, RendererFactory2, Inject, PLATFORM_ID } from '@angular/core'
import { isPlatformBrowser } from '@angular/common'

@Injectable({
  providedIn: 'root'
})
export class SeoService {
  private renderer: Renderer2

  constructor(
    private rendererFactory: RendererFactory2,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.renderer = this.rendererFactory.createRenderer(null, null)
  }

  updateCanonical(url: string) {
    if (!isPlatformBrowser(this.platformId)) return

    let link = document.querySelector("link[rel='canonical']") as HTMLLinkElement | null

    if (!link) {
      const newLink = this.renderer.createElement('link') as HTMLLinkElement
      newLink.setAttribute('rel', 'canonical')
      this.renderer.appendChild(document.head, newLink)

      link = newLink
    }

    link.setAttribute('href', url)
  }
}
